import * as React from 'react'
import { connect } from 'react-redux'
import { Button } from '@amzn/dvui/dist/Button'
import { ModalTrigger, ModalRenderPropArgs } from '@shared/utils/modalTrigger/ModalTrigger'
import { IDetailPageState } from '../../reducers'
import * as utilityClasses from '../utilityClasses.module.scss'
import { TextLocalizer } from '../localizer/localizer'

type PurchaseFailedModal = ReturnType<typeof mapStateToProps>

export const PurchaseFailedModalComponent = ({ purchase }: PurchaseFailedModal) => {
  const isOpen = Boolean(purchase && purchase.failed)

  return (
    <ModalTrigger
      modalId='dvui-close-overlay-purchase-failed'
      isOpen={isOpen}
      modalContent={<TextLocalizer stringID='AVOD_DP_E_error_text' />}
      modalFooter={
        ({ closeModal }: ModalRenderPropArgs) => {
          const handleClick = () => {
            window.location.reload(true)
            closeModal()
          }
          return (
            <Button className={utilityClasses.alwaysInline} onClick={handleClick} >
              <TextLocalizer stringID='AVOD_DP_E_error_ok' />
            </Button>
          )
        }
      } />
  )
}

const mapStateToProps = (state: IDetailPageState) => ({
  purchase: state.purchase
})

export const PurchaseFailedModal = connect(mapStateToProps)(PurchaseFailedModalComponent)
